import { PlatformSDKShape } from '../PlatformSDKShape';
import { BaseSDKShape } from '../BaseSDKShape';
import type { SiteLocale } from '@wix/public-editor-platform-interfaces';

export type { SiteLocale } from '@wix/public-editor-platform-interfaces';

type ThemeCustomProperty =
  | {
      type: string;
      value: string;
      displayName: string;
    }
  | { error: string };

type FontOption = {
  displayName: string;
  characterSets: string[];
  fontFamily: string;
  cssFontFamily: string;
  style: { weight: number; style: string }[];
};

export class InfoSDKShape extends BaseSDKShape {
  async getViewMode() {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.info.getViewMode();
  }

  async getLanguageCode() {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.info.getLanguageCode();
  }

  async getLocales(): Promise<SiteLocale[]> {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.info.getLocales() as SiteLocale[];
  }

  async getSiteDirection() {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.info.getSiteDirection();
  }

  async siteHasCustomClasses() {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.info.siteHasCustomClasses();
  }

  async getThemeCustomProperties(filter: {
    keys?: string[];
  }): Promise<Record<string, ThemeCustomProperty>> {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.info.getThemeCustomProperties(filter);
  }

  async getSiteFonts(filter: {
    keys?: string[];
  }): Promise<Record<string, FontOption>> {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.info.getSiteFonts(filter) as Record<string, FontOption>;
  }

  async getFontFamilyDisplayName(
    fontFamily: string,
  ): Promise<string | undefined> {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.info.getFontFamilyDisplayName(fontFamily);
  }

  async getMetaSiteId(): Promise<string> {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.info.getMetaSiteId();
  }
}

export default new PlatformSDKShape(InfoSDKShape)
  .withPublicMethod('getViewMode')
  .withPublicMethod('getLanguageCode')
  .withPublicMethod('getLocales')
  .withPublicMethod('getSiteDirection')
  .withPublicMethod('siteHasCustomClasses')
  .withPublicMethod('getThemeCustomProperties')
  .withPublicMethod('getSiteFonts')
  .withPublicMethod('getFontFamilyDisplayName')
  .withPublicMethod('getMetaSiteId')
  .build();
